import { type HTMLAttributes } from 'react';
import { cn } from '@/utils/cn';

/**
 * PageColumn — the standard responsive centred content column.
 *
 * Renders the project-standard responsive col-span:
 * - Mobile:  full width  (`col-span-12`)
 * - Tablet:  6 of 12 cols, centred (`col-span-6 col-start-4`)
 * - Desktop: 4 of 12 cols, centred (`col-span-4 col-start-5`)
 *
 * Use `className` to add per-screen vertical padding (e.g. `py-8`).
 *
 * Must be rendered inside a `PageGrid` (or any element with `grid-primer`).
 *
 * @example
 * <PageGrid>
 *   <PageColumn className="py-8">
 *     <MyContent />
 *   </PageColumn>
 * </PageGrid>
 */
export interface PageColumnProps extends HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
}

export function PageColumn({ className, children, ...props }: PageColumnProps) {
  return (
    <div
      className={cn(
        'col-span-12',
        'md:col-span-6 md:col-start-4',
        'lg:col-span-4 lg:col-start-5',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}

export default PageColumn;
